import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import {
  PingboardConfig,
  PingboardFieldCompact
} from '@dadohr/shared/domainTypes/integrations/pingboard';
import { CF, FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import { callFirebaseFunction } from '../../../../../../services/firebaseFunctions';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toPingboardConfigDoc = generateToDocFn<PingboardConfig>();

const COLLECTION = FS.pingboardIntegrationConfig;
const collection = () => store().collection(COLLECTION);

export const pingboardConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toPingboardConfigDoc
);

export const usePingboardConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(pingboardConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<PingboardConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,
            clientId: '',
            clientSecret: ''
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removePingboardConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};

export const getPingboardFields = async (orgId: string) => {
  const result = await callFirebaseFunction<PingboardFieldCompact[]>(
    CF.pingboard.getFields,
    { orgId }
  );

  return result;
};
